import { PublicSectionGate, PublicShell } from '@components/PublicPage'
import { Hero, TripOverview } from '@components/TripOverview'
import {
	buildPublicShareFlags,
	buildPublicTripOverviewData,
	publicSectionPath,
	TripOverviewSection,
} from '@components/TripOverview/core'
import { usePublicOverview } from '@hooks'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { config } from '../../config'
import CtaBand from './CtaBand'
import { Container } from './PublicTripOverviewPage.styles'

/**
 * The public Shared trip page at `/shared/trips/:tripCode` — standalone (no app
 * Layout / auth). Renders the member bento in `public` mode, where per-section
 * share flags gate each tile into detail / empty / teaser.
 */
const PublicTripOverviewPage: React.FC = () => {
	const { tripCode } = useParams<{ tripCode: string }>()
	const navigate = useNavigate()
	const query = usePublicOverview(tripCode)

	const handleNavigate = (section: TripOverviewSection) => {
		if (tripCode) navigate(publicSectionPath(tripCode, section))
	}

	return (
		<PublicSectionGate
			query={query}
			loadingLabel="Loading trip…"
			unavailableTitle="Trip Unavailable"
			unavailableMessage="This trip doesn't exist or has been set to private by the trip owner."
		>
			{data => {
				const overviewData = buildPublicTripOverviewData(data)
				const shareFlags = buildPublicShareFlags(data)
				return (
					<PublicShell>
						<Container>
							<Hero hero={overviewData.hero} />
							<TripOverview
								data={overviewData}
								mode="public"
								shareFlags={shareFlags}
								onNavigate={handleNavigate}
								onSetTripDates={() => {}}
							/>
							<CtaBand getOrbitUrl={config.getOrbitUrl} />
						</Container>
					</PublicShell>
				)
			}}
		</PublicSectionGate>
	)
}

export default PublicTripOverviewPage
